import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Flex, UiText } from '@shared/ui';

import cls from './Spending.module.css';

interface ISpendingProps {
    value: string;
    className?: string;
}
export const Spending = ({ value, className }: ISpendingProps) => {
    const { t } = useTranslation();
    return (
        <Flex className={cn(cls.Spendings, className)} gap={8}>
            <UiText tag="h4" variant="mediumPlain" weight="bold" className={cls.SpendingsLabel}>
                {t('PurchaseChart.Spending.text')}{' '}
            </UiText>
            <UiText tag="h2" variant="mediumPlain" weight="bold">
                {value}
            </UiText>
        </Flex>
    );
};
